import React from 'react';
import { connect } from 'react-redux';
import { Container } from 'semantic-ui-react';
import { goBack, push } from 'connected-react-router';
import { RouteComponentProps } from 'react-router';
import useAxios from 'axios-hooks';
import { IBuilding, IEhs } from '@relab/alstom-ptw-shared';

import { HeaderComponent } from '../components/HeaderComponent';
import { NavBar } from '../components/NavBar';
import { EhsViewComponent } from '../components/ehs/EhsViewComponent';
import { ehsAction } from '../redux/actions';

interface EhsViewSceneProps extends RouteComponentProps<{ ehsId: string }> {
  goBack: typeof goBack;
  push: typeof push;
  ehsAction: typeof ehsAction;
  ehs: IEhs;
}

const PEhsViewScene: React.FC<EhsViewSceneProps> = ({
  match: {
    params: { ehsId },
  },
  goBack,
  push,
}) => {
  const [{ data: buildings = [] }] = useAxios<IBuilding[]>('/buildings');

  return (
    <>
      <HeaderComponent />
      <NavBar />
      <Container fluid>
        <EhsViewComponent ehsId={ehsId} buildings={buildings} onCancel={goBack} onUpdated={() => push('/ehss')} />
      </Container>
    </>
  );
};

export const EhsViewScene = connect(null, { goBack, push })(PEhsViewScene);
